export const CHAT_LIST_FAIL = 'CHAT_LIST_FAIL'
export const CHAT_LIST_SUCCESS = 'CHAT_LIST_SUCCESS'
export const CHAT_LIST_LOADING = 'CHAT_LIST_LOADING'

export const MESSAGE_LIST_FAIL = 'MESSAGE_LIST_FAIL'
export const MESSAGE_LIST_SUCCESS = 'MESSAGE_LIST_SUCCESS'
export const MESSAGE_LIST_LOADING = 'MESSAGE_LIST_LOADING'

export const SEND_MESSAGE_FAIL = 'SEND_MESSAGE_FAIL'
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS'
export const SEND_MESSAGE_LOADING = 'SEND_MESSAGE_LOADING'

export const CHAT_SEARCH_FAIL = 'CHAT_SEARCH_FAIL'
export const CHAT_SEARCH_SUCCESS = 'CHAT_SEARCH_SUCCESS'
export const CHAT_SEARCH_LOADING = 'CHAT_SEARCH_LOADING'
